export const users = {
  title_create: "Créer un  utilisateurs",

  form: {
    name: "Nom",
    name_required: "Le nom est requis",

    email: "Email",
    email_required: "L'Email est requis",

    role: "Rôle",
    title_edit: "Modifier un  utilisateurs",
    creating: "Création en cours...",
    submit: "Créer",
    name_placeholder: "Nom du utilisateur",
    email_placeholder: "Email",

    role_placeholder: "ID du rôle",
    title: "Modifier un utilisateur",
    title: "Créer un client",
    name: "Nom",

    email: "Email",

    updating: "Mise à jour...",
    update: "Modifier",
    create_success: "Client crée avec succès!",
    update_success: "Client mis à jour avec succès!",
    deactivate_success: "Client desactivé avec succès!",
    create_error: "Erreur lors de la création du client",
    update_error: "Erreur lors de la mise à jour du client",
    deactivate_error: "Erreur lors de la desactivation du client",
    status: "Statut",
    select_role: "Sélectionner un rôle",
  },

  table: {
    status: "Statut",
    isVerified: "Vérifié",
    createdAt: "Date de création",
  },
  actions: {
    edit: "Modifier",
    consulter: "Consulter",
    disable: "Désactiver",
    enable: "Activer",
  },
  header_title: "Liste des utilisateurs",
};
